import { Modal, ModalMixin, ModalEventsMixin } from 'react-modal-box';
import Audio from './audio';
import MultiChoice from './multichoice';
import ProgressBar from './progressbar';
import MessageModal from '../messagemodal';
import reactMixin from 'react-mixin';
import React from 'react';
import { getRespondentSurveyMusic, updateRespondentSurveyMusic, getRespondentSurveyMusic2, stopMusic } from '../../api/respondentsurveyapi';
import { updateRespondentSurveyPlaylistMusic } from '../../api/respondentsurveyplaylistapi';
import _ from 'lodash';

const modalStyles = {
  modalBackdrop: {
    // Backdrop styles
  },
  modalContainer: {
    minWidth: 280,
    maxWidth: 560,
    maxHeight: '80%',
    width: '40%',
    padding: 0,
    backgroundColor: 'transparent'
  },
  modalDismiss: {
    visibility: 'collapse'
  },
  modalIcon: {
    // Default Icon styles, element inside the modal Dismiss
  }, 
  modalHeader: {
    margin: 0
  },
  modalContent: {
    margin: 0
  },
  modalFooter: {
    margin: 0
  }
};

class App extends React.Component {
	constructor(props) {
		super(props);

		if(this.props.respondent_survey && this.props.respondent_survey.id) {
			this.state = {
				respondent_survey: this.props.respondent_survey,
				disabled: false
			}
		} else {
			this.state = {
				default_messages: this.props.respondent_survey,
				respondent_survey: null,
				disabled: false
			}
		}
		this.onAnswerQuestion = this.onAnswerQuestion.bind(this);
	}

	get id() {
		return this.props.id || this.props.match.params.id;
	}

	get reference() {
		return this.props.reference || this.props.match.params.reference;
	}

	componentDidMount() {
		getRespondentSurveyMusic2(this.id, this.reference)
		.then((respondent_survey) => {
			if(respondent_survey && respondent_survey.id) {
				this.setState({ respondent_survey });
			} else {
				this.setState({default_messages: respondent_survey});
			}
		})
		.catch((err) => {
			const props = MessageModal.presets.simple;
			props.app = this;
			props.message = err.message;
			this.modalShow(
        <MessageModal {...props}/>
      );
		});
	}

	componentDidUpdate(prevProps, prevState) {
		const title = _.get(this.state, 'respondent_survey.title') || '';
		document.title = title.length === 0 ? 'Surveybot' : title;
	}

	onAnswerQuestion(params) {
		if (!this.audio.currentPlayerPlayed) {
				const props = MessageModal.presets.simple;
				props.app = this;
				props.message = 'Please play this song first.';
				this.modalShow(
	        <MessageModal {...props}/>
	      );
			return;
		}
			
		params.ref = this.reference;

		const no_next_song = params.current_file_id == null;

    	this.setState({ disabled: true });
		// Send update
		
		updateRespondentSurveyPlaylistMusic(this.current_playlist.id, params)
		.then((respondent_survey) => {
			const no_audio = respondent_survey.no_audio;
			const isFinished = no_audio || no_next_song;
			const newPlaylist = respondent_survey.new_playlist;
			if (newPlaylist) {
				this.audio.currentPlayer.pause();
				const props = MessageModal.presets.continue;
				props.app = this;
				props.message = (respondent_survey.next_playlist_message == null || respondent_survey.next_playlist_message.length == 0) ? 'Want another chance to win? Listen to some more songs and get another entry!' : respondent_survey.next_playlist_message;
				props.buttons = [{
					title: (respondent_survey.next_playlist_deny_text == null || respondent_survey.next_playlist_deny_text.length == 0) ? 'No thanks' : respondent_survey.next_playlist_deny_text,
					style: 'cancel',
					value: false
				},
				{
					title: (respondent_survey.next_playlist_confirm_text == null || respondent_survey.next_playlist_confirm_text.length == 0) ? 'Let\'s go' : respondent_survey.next_playlist_confirm_text,
					style: 'confirm',
					value: true
				}];
				props.onResult = (selectedVal) => {
					if(selectedVal) {
						//continue with next playlist
						this.setState({
							respondent_survey
						});

						this.setState({ disabled: false });
						return;
					} else {
						stopMusic(this.id, this.reference).then((response) => {
							if (!response.ok) {
								throw Error(response.statusText);
							}
							//end
							//stop the song
							const MessengerExtensions = window.MessengerExtensions;
							MessengerExtensions.requestCloseBrowser(function success() {}, function error(err) { console.log(err); });
							return;
						});
					}
				}
				this.modalShow(
	        	<MessageModal {...props}/>)
			} else if (isFinished) {
				//stop the song
				this.audio.currentPlayer.pause();
				const MessengerExtensions = window.MessengerExtensions;
				MessengerExtensions.requestCloseBrowser(function success() {}, function error(err) { console.log(err); });
				return;
			} else {
				this.setState({
					respondent_survey
				});

				this.setState({ disabled: false });
			}
		})
		.catch(() => {
			this.setState({ disabled: false });
		});
	}

	get current_playlist() {
		return this.state.respondent_survey.current_playlist;
	}

	get current_song() {
		return this.current_playlist.current_survey_playlist_file;
	}

	get current_question() {
		return this.state.respondent_survey.current_playlist.current_question;
	}

	get answer() {
		const respondent_survey = this.state.respondent_survey;
		const answer = respondent_survey.answer;
		return answer;
	}

	getPercentage(for_content) {
		if (for_content == null) {
			return 0;
		}
		let percentage = for_content.order_id / this.state.respondent_survey.total_audios;
		return isNaN(percentage) ? 0 : percentage;
	}

	render() {
		if (this.state.respondent_survey == null) {
			const props = MessageModal.presets.simple;
			props.app = this;
			props.message = this.state.default_messages && this.state.default_messages.already_completed_message ? this.state.default_messages.already_completed_message : 'This survey has already been completed.';
			props.buttons = [{
				title: this.state.default_messages && this.state.default_messages.already_completed_confirm_text ? this.state.default_messages.already_completed_confirm_text : 'OK',
				style: 'confirm'
			}];
			props.onResult = (selectedVal) => {
				//end
				//stop the song
				const MessengerExtensions = window.MessengerExtensions;
				MessengerExtensions.requestCloseBrowser(function success() {}, function error(err) { console.log(err); });
				return;
			
			}
			this.modalShow(<MessageModal {...props}/>)
			// TODO loading state
			return (
			<div>

				<Modal customStyles={modalStyles} />
			</div>
			);
		}
		const for_content = this.current_song;
		// .for_content_id == null ? null : 
		// this.state.respondent_survey.audios.find((q) => {
		// 	return q.id === this.current_question.for_content_id;
		// });

		const audio = for_content == null ? null : <Audio ref={ a => {
			this.audio = a;
		}} current_song={for_content} current_playlist={this.current_playlist} respondent_survey={this.state.respondent_survey}/>;

		const percentage = this.getPercentage(for_content)

		return (
			<div>
				<ProgressBar percentage={ percentage } />
				{audio}
				<MultiChoice 
				current_playlist={this.current_playlist}
				respondent_survey={this.state.respondent_survey}
				current_song={this.current_song}
				answer={this.answer} 
				question={this.current_question} 
				onAnswerQuestion={this.onAnswerQuestion}
				disabled={this.state.disabled}
				/>

				<Modal customStyles={modalStyles} />
			</div>
		);
	}
}

reactMixin(App.prototype, ModalMixin);
reactMixin(App.prototype, ModalEventsMixin);

export default App;


// WEBPACK FOOTER //
// ./src/components/music/app.jsx